import React, { useEffect, useState } from "react";
import api from "../../common/services/api";
import Loading from "../../components/Loading";
import Notification from "../../components/Notification";
import SimulateStats from "../../components/ResultPage";

const SpecificSimulate = (props) => {

    const [loading, setLoading] = useState(false);
    const [dataComponents, setDataComponents] = useState(null);

    const getSpecificSimulateData = async () => {
        try {
            setLoading(true);
            const simulateID = props.match.params.id;

            const { data } = await api.get(`/exam/result/${simulateID}`);

            const obj = {
                ...props,
                result: data
            };

            setDataComponents(obj);
        } catch (error) {
            Notification.error({
                message: 'Algo deu errado'
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getSpecificSimulateData();
    }, []);

    return (
            <Loading loading={loading} customLoadingElement={false}>
                {
                    dataComponents && <SimulateStats data={dataComponents} componente={'specific'} />
                }
            </Loading>
    )
}

export default SpecificSimulate
